import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f85aaa9c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f85aaa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85aaa9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f85aaa9c')) {
      api.createRecord('f85aaa9c', component.options)
    } else {
      api.reload('f85aaa9c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f85aaa9c&scoped=true&", function () {
      api.rerender('f85aaa9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bANi4mp1Z0f0/JS/comp/DocBox.vue"
export default component.exports